export default __webpack_public_path__ + "static/media/Finance.61597dea.png";